import { atom } from "recoil";

export const sidebarWidthState = atom({
  key: "sidebarWidthState",
  default: 0,
});
